/*
call function or emitting "clickSingle"/"clickDouble" or run function

Usage:

ES6:
import vo from "vue-clicks.js"
Vue.use( vo )

ES5:
var vo = require("vue-clicks.js")
Vue.use( vo )

template:
<div
  v-clicks="myfunc"
>
...
</div>

<div v-clicks:300="myfunc" ...
<div v-clicks:1000 @clickSingle="" @clickDouble="" ...
<div
*/
let vueClicks = {};

const emit = ( vnode, name, data ) => {
	const handlers = ( vnode.data && vnode.data.on ) || ( vnode.componentOptions && vnode.componentOptions.listeners );
	if ( handlers && handlers[ name ] ) handlers[ name ].fns( data );
};

const rise = ( vnode, el, binding, eventType, eventData ) => {
	if ( binding.value || binding.expression ) {
		if ( typeof binding.value === "function" ) binding.value.bind( vnode.context )( eventType, eventData );
		else new Function( binding.expression.replace( /^(")(.*?)\1$/, "$2" ) ).bind( vnode.context )( eventType, eventData );
	}
	else emit( vnode, eventType, eventData );
};

vueClicks.install = function ( Vue ) {
	Vue.directive(
		"clicks",
		{
			bind( el, binding, vnode ) {
				let clicks = 0;
				let tid = null;
				let delay = 300;
				if ( binding && ( "arg" in binding ) ) {
					const arg = parseInt( binding.arg, 10 );
					if ( !isNaN( arg ) && arg > 0 ) delay = arg;
					else console.error( "vue-clicks: delay must be unsigned integer, got \"" + arg + "\"" );
				}

				const handle = e => {
          clicks++;

          if ( clicks === 1 ) {
          	if ( tid ) clearTimeout( tid );
            tid = setTimeout(
            	() => {
            		clicks = 0;
            		rise( vnode, el, binding, "clickSingle", e );
            	},
							delay
						);
          }
          else {
            clearTimeout( tid );
            tid = null;
            clicks = 0;
          	rise( vnode, el, binding, "clickDouble", e );
          }

					e.preventDefault();
					return false;
				};

				el._vue_mixin_clicks_handle_ = handle;
				el.addEventListener( "mousedown", handle );
			},
			
			unbind( el ) {
				if ( el && el._vue_mixin_clicks_handle_ ) {
					el.removeEventListener( "mousedown", el._vue_mixin_clicks_handle_ );
					delete el._vue_mixin_clicks_handle_;
				}
			}
		}
	);
};

if ( typeof window !== "undefined" && window.Vue ) {
	window.Vue.use( vueClicks )
}

export default vueClicks;
